import merge from 'lodash/merge';

export default class UserType {
    static NAME = 'usertype';

    static getDetailsConfig = () => ({
      url: '/user-type',
    });

    constructor(user) {
      this.init(user);

      this.country = user.country;
      this.isCrmManager = user.isCrmManager;
      this.isSosManager = user.isSosManager;
      this.isB2BMasterUser = user.isB2BMasterUser;
      this.b2bSessionId = user.b2bSessionId;
      this.isAnonymous = user.isAnonymous;
      this.newCart = user.newCart;
      this.lang = user.lang;
      this.userType = user.userType;
    }

    init(data) {
      merge(this, data);
    }
}
